import React from "react"
import classNames from "classnames"
import moment from "moment"

import { SLOT_MODAL_TYPE } from "./ProductionScheduleCalendar"

// import warningIcon from "../../assets/images/schedule/production-warning.svg"
import addNotesIcon from "../../assets/images/schedule/production-add-notes.svg"
import resolvedNotesIcon from "../../assets/images/schedule/production-complete-notes.svg"
import multipleNotesIcon from "../../assets/images/schedule/production-multiple-notes.svg"
import pendingNotesIcon from "../../assets/images/schedule/production-incomplete-notes.svg"
import tickIcon from "../../assets/images/icons/tick.png"

// const WARNING_MIN_LENGTH = 1
const FIRST_ELEMENT = 0

const SlotCard = props => {
    console.log("props", props)
    const {
        inventoryUsed,
        timelineOrder = {},
        slotId = "",
        isSelected = false,
        onClick = () => {},
        date,
        slot,
    } = props

    const notes = timelineOrder?.notes
    const isFuture = moment(date).isAfter(moment())

    const getIcon = () => {
        if (!slotId) return ""
        const noteCount = notes?.length || 0
        switch (true) {
            case noteCount > 1:
                return { icon: multipleNotesIcon, count: noteCount }
            case noteCount === 1:
                return notes[FIRST_ELEMENT]?.resolved
                    ? { icon: resolvedNotesIcon }
                    : { icon: pendingNotesIcon }
            default:
                return { icon: addNotesIcon }
        }
    }

    const { icon, count } = getIcon()

    return (
        <div
            className={classNames("slot-card", {
                "slot-card-selected": isSelected,
            })}
            onClick={onClick}
        >
            <div className="tooltip-container">
                <p className="tooltip-target slot-card-client trim-text pointer">
                    {" "}
                    {timelineOrder?.customerName || ""}
                </p>
                <span className="custom-tooltip">
                    {timelineOrder?.customerName}
                </span>
            </div>
            <p className="slot-card-order trim-text">{slotId}</p>
            <div className="tooltip-container">
                <p className="tooltip-target slot-card-client trim-text pointer">
                    {" "}
                    {timelineOrder?.trailer?.trailerType || ""}
                </p>
                <span className="custom-tooltip">
                    {timelineOrder?.trailer?.trailerType}
                </span>
            </div>

            {/* {warning?.length >= WARNING_MIN_LENGTH && (
            <img
               alt="warning-icon"
               src={warningIcon}
               width={15}
               height={15}
               onClick={e => onClick(e, slot, SLOT_MODAL_TYPE.WARNING)}
            />
         )} */}

            {icon && (
                <div className="d-flex align-items-center gap-1">
                    <div className="d-flex align-items-center gap-1">
                        <img
                            alt="notes-icon"
                            src={icon}
                            width={15}
                            height={15}
                            className="img"
                            onClick={e =>
                                onClick(e, slot, SLOT_MODAL_TYPE.INSPECTION)
                            }
                        />
                        {count && <span className="fs-13">{count}</span>}
                    </div>

                    <div className="d-flex align-items-center">
                        {inventoryUsed ? (
                            <div className="tooltip-container">
                                <img
                                    alt="warning-icon"
                                    src={tickIcon}
                                    width={15}
                                    height={15}
                                    className="img"
                                />
                                <span className="custom-tooltip">
                                    Inventory Used
                                </span>
                            </div>
                        ) : (
                            <div
                                className="use-inventory-btn"
                                onClick={e =>
                                    onClick(e, slot, SLOT_MODAL_TYPE.WARNING)
                                }
                            >
                                Use Inventory
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default SlotCard
